import Navbar from '../components/navbar';
import Footer from '../components/footer';
import '../App.scss';

import bird from '../components/images/merl-bird.png';

const Home = () => {
	document.title = "Coming Soon | MERL";
    return (

		<div className="App">
			<header>
				<Navbar></Navbar>
			</header>
		  
			<body>
				<div className='comingsoon white'>
					<img src={bird} alt="silhouette of a pink bird giving a side-eye" id="csBird"></img>
					<br/>
					<br/>
					<h1>Coming Soon!</h1>

				</div>
				<Footer/>
			</body>
		</div>
	  );
}

export default Home;
